import env from '../../../../env/env';

const BALL_URL = `${env.REACT_APP_STATIC_BASE_URL}marketplace/img/commons/home/certifiedball_v2.gif`;

export { BALL_URL };
